import { Ajax } from '../Core/Ajax';
import { Constants } from '../Core/Constants';
import { Storage } from '../Core/Storage';
import { AppStore } from '../Core/AppStore';
import { CalculatedCart } from '../Models/CalculatedCart';
export class CetelemProvider {

	static loadBarems(success) {
		Ajax.get(Constants.Url.Barems, null, (data) => {
			success(data);
		});
	}

	static loadInsuarences(success) {
		Ajax.get(Constants.Url.Insuarences, null, (data) => {
			success(data);
		});
	}

	static calculate(data,success) {
		Ajax.post(Constants.Url.CalculateCetelem, data, (result) => {
			success(result);
		});
	}
}
